import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { SmallLineSeparator } from '../../../../components/separator/LineSeparator';

export const AutocompleteTips: FC = () => (
  <>
    <SmallLineSeparator />
    <div className="search-bar-dropdown__cell search-bar-dropdown__tips">
      <span>
        <span className="search-bar-dropdown__tips__em">&quot;</span>
        <span className="search-bar-dropdown__tips__text">xx xxx</span>
        <span className="search-bar-dropdown__tips__em">&quot;</span>{' '}
        <span className="search-bar-dropdown__tips__text">
          <FormattedMessage id="search/components/search-bar/dropdown/AutocompleteTips.tsx/1" />
        </span>
      </span>
      <span className="search-bar-dropdown__tips__tip-next">
        <span className="search-bar-dropdown__tips__em">
          <FormattedMessage id="search/components/search-bar/dropdown/AutocompleteTips.tsx/2" />
        </span>{' '}
        <span className="search-bar-dropdown__tips__text">
          <FormattedMessage id="search/components/search-bar/dropdown/AutocompleteTips.tsx/3" />
        </span>
      </span>
    </div>
  </>
);
